module.exports = __webpack_public_path__ + "img/icon_0011.c9738747.png";